import apiFetch from '../apiFetch'

export default function (entityId, token) {
  return apiFetch({ endPoint: `document/ListByEntityId?entityId=${entityId}`, method: 'GET', token: token })
}
